import maintenance from './maintenance.module'
import siteWideAlert from './siteWideAlert.module'
export const modules = {
  maintenance,
  siteWideAlert
}
